<template>
  <div v-if="phase.active" :id="'bonusPhase_'+ index">
    <div v-if="phase.type === 'BONUS_DAILY'" class="home_bonus_box daily_bonus_box" @click.prevent="$emit('openModal')">
        <div class="bonus_col">
          <img src="static/images/daily_bonus/dailybonus.png">
        </div>
        <div class="bonus_col">
          <h2> {{ getTranslations.home_daily_bonus_header }} </h2>
          <div class="store_countdown">
            <p> {{ counter }} </p>
          </div>
        </div>
    </div>
    <div v-if="phase.type === 'POINTS'" class="home_bonus_box points_multiply_box" @click.prevent="$emit('openModal')">
      <div class="bonus_col">
        <img src="static/images/daily_bonus/points_multiply.png">
      </div>
      <div class="bonus_col">
        <h2> {{ getTranslations.home_bundle_discount_header }} </h2>
        <div class="store_countdown">
          <p> {{ counter }} </p>
        </div>
      </div>
    </div>
    <div v-if="phase.type === 'BUNDLES'" class="home_bonus_box discount_bonus_box" @click.prevent="$emit('openModal')">
      <div class="bonus_col">
        <img src="static/images/daily_bonus/bundle_discount.png">
      </div>
      <div class="bonus_col">
        <h2> {{ getTranslations.home_points_multiplier_header }} </h2>
        <div class="store_countdown">
          <p> {{ counter }} </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-box',
  props: {
    phase: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    this.initiateCountDownTimer();
  },
  methods: {
    initiateCountDownTimer() {
      const interval = 1000; // every 1 second
      let duration;
      // get time element
      // calculate difference between two times
      const eventTime = moment(this.phase.end);
      // loop to countdown every 1 second
      this.timer = setInterval(() => {
        // based on time set in user's computer time / OS
        const currentTime = moment(new Date());
        // get duration between two times
        duration = moment.duration(eventTime.diff(currentTime));
        // get updated duration
        duration = moment.duration(duration - interval, 'milliseconds');

        // if duration is >= 0
        if (currentTime.isAfter(eventTime)) {
          clearInterval(this.timer);
          // hide the countdown element
          this.counter = '';
          this.phase.active = false;
        } else {
          // otherwise, show the updated countdown
          this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        }
      }, interval);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/BonusBox.vue